import React from "react";
import moment from "moment";
import { getPlanChangeData } from "../../utils/app-helpers";
import GatsbyConfig from "../../../gatsby-config.js";

const { siteMetadata: config } = GatsbyConfig;

export default class MonthlyPaymentsCallout extends React.Component {
  render() {
    const { trip, validUntil, monthlyDisabled } = this.props;
    const tripData = config.trips[trip];
    const { planChangeDay } = getPlanChangeData(tripData, { moment });
    const cutoff = moment(validUntil || planChangeDay).format("MMMM D, YYYY");

    return (
      <div className="monthly-payments-callout">
        {monthlyDisabled ? (
          <div className="wrap">
            <h2></h2>
            <h3></h3>
          </div>
        ) : (
          <div className="wrap">
            <h2>Monthly Payments</h2>
            <h3>
              Include a one time ${tripData.subscriptionFee / 2}pp convenience
              fee and ${tripData.taxesAndFees / 2}pp taxes & fees
              <span className="divider">&nbsp;|&nbsp;</span>
              <br />
              {tripData.soldOut ? (
                <mark>Sold Out!</mark>
              ) : (
                <span>
                  Valid until: <time>{cutoff}</time>
                </span>
              )}
            </h3>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/monthly-payments-callout.js